import {
	useAcademyEvents,
	useAlerts,
	useEvents,
	useTimezones,
	useUploadFileInMemory
} from 'hooks';
import AcademyEventForm from './AcademyEventForm';
import { ImageUploader, Subheader } from 'components';
import { Button, Container } from '@mui/material';
import useAcademies from 'hooks/useAcadamies';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Check } from '@mui/icons-material';
import { validateAcademyEvent } from 'validations/academyEvent';

const AcademyEventNew = ({}) => {
	const { academy_id } = useParams();
	const { findTimezones, timezones } = useTimezones();
	const { createAcademyEvent, academyEvent, isLoading, handleChange } =
		useAcademyEvents({});
	const { academy, findAcademy } = useAcademies({});
	const { memoryFile, removeFile, handleUploadFile } = useUploadFileInMemory();

	const { showAlertError } = useAlerts();
	const navigate = useNavigate();

	const handleSaveClick = async () => {
		if (!academyEvent.academy_id) {
			showAlertError('Please select an academy for the event.');
			return;
		}

		if (!academy.timezone) {
			handleChange({
				target: {
					name: 'timezone',
					value: 'Asia/Dubai'
				}
			});
		}

		const validation = validateAcademyEvent(academyEvent);

		if (!validation.isValid) {
			validation.messages.forEach((message) => showAlertError(message));
			return;
		}
		try {
			await createAcademyEvent(academyEvent, memoryFile).finally(() => {
				navigate(`/academies/${academyEvent.academy_id}`);
			});
		} catch (error) {
			console.error('Error creating academy event:', error);
			showAlertError('Failed to create academy event.');
		}
	};

	const handleDelete = async (type) => {
		removeFile();
	};

	useEffect(() => {
		if (academy_id) {
			findAcademy(academy_id);
			handleChange({
				target: {
					name: 'academy_id',
					value: academy_id
				}
			});
		}
	}, [academy_id]);

	useEffect(() => {
		findTimezones();
	}, []);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : 'New Academy Event'}
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Save Academy Event
					</Button>
				]}
			/>
			<Container>
				<center>
					<ImageUploader
						label="Upload event image"
						imageUrl={academyEvent.image_url || memoryFile?.image_url?.url}
						handleUpload={(file) => handleUploadFile(file, 'image_url')}
						handleDelete={() => handleDelete('image_url')}
					/>
				</center>
				<AcademyEventForm
					event={academyEvent}
					handleChange={handleChange}
					academies={[academy]}
					timezones={timezones}
				/>
			</Container>
		</>
	);
};

export default AcademyEventNew;
